module.exports = __webpack_public_path__ + "img/footer_how_logo.5626953b.svg";